import { createSelector } from 'reselect';
import { RootState } from 'store/types';

/**
 * Microbiology Historical
 */
export const microbiologyHistoricalSelector = (state: RootState) =>
  state.testResults.microbiologyHistorical;

export const microbiologyHistoricalLoadingSelector = createSelector(
  microbiologyHistoricalSelector,
  microbiologyHistorical => microbiologyHistorical.isFetching
);

export const microbiologyHistoricalErrorSelector = createSelector(
  microbiologyHistoricalSelector,
  microbiologyHistorical => microbiologyHistorical.error
);

export const microbiologyHistoricalDataSelector = createSelector(
  microbiologyHistoricalSelector,
  microbiologyHistorical => microbiologyHistorical.data
);

/**
 * Download Microbiology Results
 */
export const microbiologyDetailsDownloadsSelector = (state: RootState) =>
  state.testResults.downloadMicrobiologyDetails;

export const microbiologyDetailsDownloadingSelector = createSelector(
  microbiologyDetailsDownloadsSelector,
  testResults => testResults.isDownloadingMicrobiologyDetails
);

export const microbiologyDetailsDownloadDataSelector = createSelector(
  microbiologyDetailsDownloadsSelector,
  testResults => testResults.data
);

/**
 * Share Microbiology Results
 */
export const shareMicrobiologyResultsSelector = (state: RootState) =>
  state.testResults.shareMicrobiologyResults;

export const shareMicrobiologyResultsDataSelector = createSelector(
  shareMicrobiologyResultsSelector,
  shareMicrobiologyResults => shareMicrobiologyResults.sharedMicrobiologyResultsData
);

export const shareMicrobiologyResultsSendingSelector = createSelector(
  shareMicrobiologyResultsSelector,
  shareMicrobiologyResults => shareMicrobiologyResults.isSendingMicrobiologyResults
);
